import { Sparkles } from 'lucide-react';

import { Container } from '../components/Container';
import type { LandingContent } from '../content/types';

type AiSectionProps = {
  content: LandingContent;
};

export function AiSection({ content }: AiSectionProps) {
  return (
    <section className="section ai-section" aria-labelledby="ai-title">
      <Container className="ai-section__grid">
        <div className="ai-section__marker" aria-hidden="true">
          <Sparkles size={36} />
        </div>
        <div>
          <h2 id="ai-title">{content.ai.h2}</h2>
          <p>{content.ai.body}</p>
          <ul className="ai-section__list">
            {content.ai.bullets.map((bullet) => (
              <li key={bullet}>{bullet}</li>
            ))}
          </ul>
        </div>
      </Container>
    </section>
  );
}
